import styled from 'styled-components';

export const ListViewContainer = styled.div`
  height: calc(100% - 40px);
`;
